import React, { useState, useEffect } from "react";
import {
  Card,
  Button,
  Dropdown,
  ButtonGroup,
  Tooltip,
  OverlayTrigger,
  Badge,
} from "react-bootstrap";
import { withNamespaces } from "react-i18next";
import { FaColumns } from "react-icons/fa";

const EditableDropdown = ({t, apagarWidget, isMobile, handleMouseDown, width, configurar}) => {
    return (
        <Dropdown as={ButtonGroup} alignRight>
        <Dropdown.Toggle variant="link">
          <i className="icon-gear" />
        </Dropdown.Toggle>
        <Dropdown.Menu className="dropdown-menu">
          <Dropdown.Item onClick={apagarWidget}>
            {t("widgets.remove")}
          </Dropdown.Item>
          {configurar && <Dropdown.Item onClick={configurar}>
            {t("widgets.configure")}
          </Dropdown.Item>}
          {!isMobile && (
            <>
              <Dropdown.Divider /> {/* Adiciona um separador */}
              <Dropdown>
                <Dropdown.Toggle variant="link">
                  {t("widgets.resize")}
                  <FaColumns style={{ marginLeft: "10px" }} />
                </Dropdown.Toggle>
                <Dropdown.Menu
                  style={{
                    maxHeight: width == "4" ? "150px" : "",
                    overflowY: "scroll",
                  }}
                  className="scrollBar-visible-dropdown"
                >
                  <Dropdown.Item
                    onClick={() => handleMouseDown(4)}
                    style={{
                      display: "flex",
                      justifyContent: "space-between",
                    }}
                  >
                    {t("widgets.resizeSmall")}{" "}
                    <div
                      style={{
                        justifyContent: "flex-end",
                        width: "10px",
                        borderRadius: "5px",
                        background: "black",
                      }}
                    />
                  </Dropdown.Item>
                  <Dropdown.Item
                    onClick={() => handleMouseDown(5)}
                    style={{
                      display: "flex",
                      justifyContent: "space-between",
                    }}
                  >
                    {t("widgets.resizeHalfPage")}{" "}
                    <div
                      style={{
                        justifyContent: "flex-end",
                        width: "15px",
                        borderRadius: "5px",
                        background: "black",
                      }}
                    />
                  </Dropdown.Item>
                  <Dropdown.Item
                    onClick={() => handleMouseDown(6)}
                    style={{
                      display: "flex",
                      justifyContent: "space-between",
                    }}
                  >
                    {t("widgets.resizeSemiMedium")}{" "}
                    <div
                      style={{
                        justifyContent: "flex-end",
                        width: "15px",
                        borderRadius: "5px",
                        background: "black",
                      }}
                    />
                  </Dropdown.Item>
                  <Dropdown.Item
                    onClick={() => handleMouseDown(8)}
                    style={{
                      display: "flex",
                      justifyContent: "space-between",
                    }}
                  >
                    {t("widgets.resizeMedium")}{" "}
                    <div
                      style={{
                        justifyContent: "flex-end",
                        width: "20px",
                        borderRadius: "5px",
                        background: "black",
                      }}
                    />
                  </Dropdown.Item>
                  <Dropdown.Item
                    onClick={() => handleMouseDown(12)}
                    style={{
                      display: "flex",
                      justifyContent: "space-between",
                    }}
                  >
                    {t("widgets.resizeGigant")}{" "}
                    <div
                      style={{
                        justifyContent: "flex-end",
                        width: "30px",
                        borderRadius: "5px",
                        background: "black",
                      }}
                    />
                  </Dropdown.Item>
                </Dropdown.Menu>
              </Dropdown>
            </>
          )}
        </Dropdown.Menu>
      </Dropdown>
    );
};

export default withNamespaces()(EditableDropdown);